import { NodeLibraryPermissionDto } from "../../../types/dto";
import { getBlast, isMockMode, simulateDelay } from "../../api";

export const getNodeData = ({ id }: { id: string }) => {
	if (isMockMode()) {
		const testData = {
			id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
			name: "Test Name",
			type: 1,
			updateCount: 0,
			ownedByOrgId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
			ownedByOrg: {
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
			},
			ownedByUserId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
			ownedByUser: {
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				email: "test.mctestie@mgaol.abc",
				firstName: "Test",
				lastName: "McTestie",
			},
			lastUpdatedUtc: "2023-08-02T00:04:57.8886146Z",
			isDeleted: true,
			userCanAdmin: true,
			userCanWrite: true,
			userAssociations: [
				{
					user: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						email: "test.mctestie@mgaol.abc",
						firstName: "Test",
						lastName: "McTestie",
					},
					hasWriteAccess: true,
				},
			],
			siteAssociations: [],
			isVisibleToOrg: true,
			isWritableByOrg: true,
		};
		return simulateDelay(
			50,
			() => testData
		) as Promise<NodeLibraryPermissionDto>;
	}

	return getBlast(
		`nodelibrary/getwithpermissions?id=${id}`
	) as Promise<NodeLibraryPermissionDto>;
};
